import Table from '@common/components/Table';
import Pagination from '@common/components/Pagination';
import EmptyState from '@common/components/EmptyState';
import * as styles from './index.module.css';

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

function TableWithPagination({
  // Loading/Error state props
  isLoading = false,
  error = null,
  errorTranslationKey,
  // Empty state props
  emptyStateTranslationKey = 'common.noRecordsToPresent',
  emptyStateType = 'no-data',
  // Pagination props
  pageIndex,
  pageSize,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
  canPreviousPage,
  canNextPage,
  onPageSizeChange,
  onPreviousPage,
  onNextPage,
  showPagination = true,
  // All Table props are forwarded
  ...tableProps
}) {
  const { totalCount = 0, data = [] } = tableProps;
  const shouldShowPagination = showPagination && totalCount > 0;
  const isEmpty = data.length === 0;

  // Loading state
  if (isLoading) {
    return (
      <div className={styles['table-container']}>
        <EmptyState type="loading" />
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className={styles['table-container']}>
        <EmptyState
          type="error"
          message={error}
          translationKey={errorTranslationKey}
        />
      </div>
    );
  }

  // Empty state (no data)
  if (isEmpty) {
    return (
      <div className={styles['table-container']}>
        <EmptyState
          type={emptyStateType}
          translationKey={emptyStateTranslationKey}
        />
      </div>
    );
  }

  return (
    <>
      <div className={styles['table-container']}>
        <Table {...tableProps} />
      </div>
      {shouldShowPagination && (
        <Pagination
          pageIndex={pageIndex}
          pageSize={pageSize}
          pageSizeOptions={pageSizeOptions}
          totalCount={totalCount}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          onPageSizeChange={onPageSizeChange}
          onPreviousPage={onPreviousPage}
          onNextPage={onNextPage}
        />
      )}
    </>
  );
}

export default TableWithPagination;
